module.exports = __webpack_public_path__ + "img/products-1.827069f0.png";